// extracted by mini-css-extract-plugin
module.exports = {"container":"BeneficiaryTable_container__1ixyq"};